import type { MessageDto } from "@multi-chat/shared";
import { useTranslation } from "react-i18next";
import { conversationDateLabel, messageDisplayTimestampIso } from "../conversation-date.js";

export function ConversationDateSeparator({
  message,
  locale,
  nowMs,
}: {
  message: MessageDto;
  locale: string;
  nowMs: number;
}): React.JSX.Element | null {
  const { t } = useTranslation();
  const iso = messageDisplayTimestampIso(message);
  const text = conversationDateLabel(iso, locale, nowMs, (key) => {
    const value = t(key);
    return typeof value === "string" ? value : key;
  });
  if (!text) return null;

  return (
    <li className="flex list-none justify-center pt-3.5 pb-2">
      <time
        dateTime={iso}
        className="rounded-full bg-inbox-pill px-2.5 py-[3px] text-[0.71875rem] font-medium text-inbox-muted"
      >
        {text}
      </time>
    </li>
  );
}
